import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import DataFileBoxV2 from 'v2/DataFiles/DataFileBoxV2/DataFileBoxV2';
import { ProposalEntity, SearchEntity, User } from 'v2/models';
import SearchProviderFilterView from '../ActiveDataRequests/ProposalRespondModal/SearchProviderFilterView';
import styles from './dataProviderResponse.module.scss';

interface DataProviderResponseProps {
  proposal: ProposalEntity;
  user: User;
  expanded?: boolean;
}

const DataProviderResponse = ({
  proposal,
  user,
  expanded = false,
}: DataProviderResponseProps) => {
  const [showMore, setShowMore] = useState(expanded);

  if (!proposal.data_provider_response) {
    return null;
  }

  const wasRespondedByMe =
    proposal.data_provider_response?.submitted_by?.username === user.username;

  const submittedBy = proposal.data_provider_response?.submitted_by;

  const shouldShowShowMoreBtn =
    !expanded &&
    (proposal.data_provider_response?.answers.length ||
      (proposal.search as SearchEntity).filters.length ||
      proposal.data_provider_response?.data_files.length);

  const renderQuestionsAnswers = () => {
    const questionsNumber = proposal.data_provider_response?.answers.length;
    if (questionsNumber === undefined) return null;
    return (
      <>
        {questionsNumber > 0 && <h6>Questions ({questionsNumber})</h6>}
        {proposal.data_provider_response?.answers.map((item) => (
          <div className={styles.section} key={item.question.id}>
            <h5>{item.question.name}</h5>
            <p>{item.response}</p>
          </div>
        ))}
      </>
    );
  };

  const renderFilters = () => {
    const filters = (proposal.search as SearchEntity).filters;
    return filters.length ? (
      <div className={styles.section}>
        <h6>Requirements ({filters.length})</h6>
        <SearchProviderFilterView filters={filters} />
      </div>
    ) : null;
  };

  const renderDataFiles = () => {
    return proposal.data_provider_response?.data_files.length ? (
      <div className={styles.section}>
        <h6>Attached Files</h6>
        {proposal.data_provider_response?.data_files?.map((dataFile) => (
          <DataFileBoxV2
            key={dataFile.id}
            className="mb-3"
            data={dataFile}
            allowDownload={true}
          />
        ))}
      </div>
    ) : null;
  };

  return (
    <div
      className={styles.providerResponseContainer}
      data-testid="dataProviderResponse"
    >
      <div className={styles.section}>
        <h5>
          {wasRespondedByMe
            ? 'Your Response'
            : `${submittedBy?.first_name} ${submittedBy?.last_name} Response`}
        </h5>
        <p>{proposal.data_provider_response?.response}</p>
      </div>

      {showMore ? (
        <span>
          {renderQuestionsAnswers()}
          {renderFilters()}
          {renderDataFiles()}
        </span>
      ) : null}
      {shouldShowShowMoreBtn ? (
        <Button
          className="p-0"
          variant="link"
          onClick={() => setShowMore(!showMore)}
          aria-label="providerResponseShowMore"
        >
          {showMore ? 'Show Less' : 'Show More'}
        </Button>
      ) : null}
    </div>
  );
};

export default DataProviderResponse;
